'use strict';

export function TaskDependencyDomainProvider() {
  return {
    $get: ['FirebaseUtil', 'AbstractRelationClass',
      function (FirebaseUtil, AbstractRelationClass) {
        function TaskDependencyDomain(data) {
          AbstractRelationClass.call(this, TaskDependencyDomain, data);
        }

        AbstractRelationClass.__inheritFrom(TaskDependencyDomain, 'TaskDependencyDomain');

        TaskDependencyDomain.$constraints.addConstraints({
          duration: {type: 'number', defaultValue: 0}, // value is stored in seconds
          updatedBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        return TaskDependencyDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/tasks/domain/TaskDependencyDomain.js